<template>
  <div>
    <div class="resourceContentContainer" ref="resourceContentContainer">
      <div class="headerText">Resources</div>
      <div
        class="singleResource"
        v-for="(resource, index) in data"
        :key="index"
        @click="resourceClicked(resource)"
      >
        <div class="textContainer">
          <div class="titleText">
            {{ resource.instanceData.name }}
          </div>
          <div class="timeText">
            {{ resource.startTime }}  <span v-if="!resource.isActive">({{ resource.timeDifference }})</span><span v-if="resource.isActive">({{ resource.remainingTime }})</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../scss/resource-content.css";
import timeMixin from '../mixins/timeMixin'
import Vue from 'vue'

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  created() {
    this.data.forEach((element) => {
      element.parsedStart = this.convertHoursMinsSecsToSeconds(element.startTime);
      element.parsedEnd = this.convertHoursMinsSecsToSeconds(element.endTime);
      Vue.set(element, "remainingTime", "");
      Vue.set(element, "timeDifference", this.convertSecondsToHourMinsSecs(element.parsedEnd-element.parsedStart));
      Vue.set(element, "isActive", false);
    });
    // window.addEventListener("resourceButtonEvent",this.speakerEvent)
  },
  data() {
    return {
      isLoaded: false,
      scrollSaveCount: 0
    };
  },
  methods: {
    runFirstLoad() {
    },
    resourceClicked(item) {
      let customEvent = new CustomEvent('openLink',{
          detail: { 
            routeLink: item.instanceData.link,
            alertText: item.instanceData.alertText?item.instanceData.alertText:null
          }
      });
      window.dispatchEvent(customEvent)
    },
    // speakerEvent(e){
    //   if(e.detail.state=="clicked"){
    //     this.scrollSaveCount = this.$parent.saveScrollState(this);
    //     var resourceIndex = this.data.findIndex(x=>x.instanceData.name==e.detail.data.name)
    //     let resource=this.$refs.resourceContentContainer.children[resourceIndex]
    //     if(resource!=null&&!resource.classList.contains("focusBlink")){
    //       resource.classList+=" focusBlink"
    //     }
    //     setTimeout(() => {
    //       if(resource!=null)
    //         resource.classList.remove("focusBlink")
    //     }, 4000);
    //   }
      // else if(e.detail.state=="hidden"){
      //   this.$parent.cancelAutoScrollState(this.scrollSaveCount);
      // }
    // },
  },
  mixins:[timeMixin]

};
</script>
